



















































import productSearchApi from '@/api/productSearchApi';
import IconCancel from '@/assets/svg/icons/icon-cancel.svg?inline';
import IconPlus from '@/assets/svg/icons/icon-plus.svg?inline';
import IconMinus from '@/assets/svg/icons/icon-minus.svg?inline';
import IconTrash from '@/assets/svg/icons/icon-trash.svg?inline'
import * as ElasticSearch from '@/typings/interfaces/ElasticSearch';
import * as ProductSearch from '@/typings/interfaces/ProductSearch';
import gsap from 'gsap';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {OrderableItem} from "@/typings/types/OrderableItem";

@Component({
  components: {IconCancel, IconPlus, IconMinus, IconTrash},
})
export default class BasketItem extends Vue {
  @Prop({required: true}) private item!: OrderableItem;
  private source: ProductSearch.Source = {} as ProductSearch.Source;
  private amountOfSamples: number = 0;

  get finish(): ProductSearch.Finish | undefined {
    return this.source?.finishes?.find(value => value.id === this.item.id);
  }

  public getProductImage(finish: ProductSearch.Finish): string | null {
    if (finish.thumbnailImage?.renditions) {
      return _mgnl.contextPath + finish.thumbnailImage.renditions.productImage.link;
    }

    return null;
  }

  get quantity() {
    return this.item?.quantity || 0;
  }

  get totalCartQuantity() {
    return this.$store.getters['shoppingCart/count'];
  }

  get cantIncrement() {
    return this.quantity >= 10 || this.totalCartQuantity >= 10
  }

  get cantDecrement() {
    return this.quantity <= 1;
  }

  get application() {
    return this.source?.productCategory?.application;
  }

  removeFromCart(cartEntry: OrderableItem) {
    this.$store.dispatch('shoppingCart/removeItem', new OrderableItem(cartEntry.id, 0));
  }

  incrementAmount(cartEntry: OrderableItem) {
    this.$store.commit('shoppingCart/mutateAmountOnItem', {item: new OrderableItem(cartEntry.id, cartEntry.quantity), type: "INCREMENT"});
  }

  decrementAmount(cartEntry: OrderableItem) {
    this.$store.commit('shoppingCart/mutateAmountOnItem', {item: new OrderableItem(cartEntry.id, cartEntry.quantity), type: "DECREMENT"});
  }

  updateAmount(cartEntry: OrderableItem, amount: number) {
     if (cartEntry.quantity > amount) {
       this.$store.commit('shoppingCart/mutateAmountOnItem', {item: new OrderableItem(cartEntry.id, cartEntry.quantity), amount, type: "DECREMENT"})
     } else if (cartEntry.quantity < amount) {
       this.$store.commit('shoppingCart/mutateAmountOnItem', {item: new OrderableItem(cartEntry.id, cartEntry.quantity), amount, type: "INCREMENT"})
     }
  }

  @Watch('quantity')
  onQuantityUpdate() {
    this.amountOfSamples = this.quantity;
    const tl = gsap.timeline();
    const wrapper = (this.$refs.wrapper as HTMLElement);
    tl.to(wrapper, {opacity: 0.25, duration: 0.2});
    tl.to(wrapper, {opacity: 1, duration: 0.2});
  }

  private beforeMount() {

    if (this.item.itemExists()) {
      productSearchApi.performSearchWithFilters({
        'finishes.id': this.item.id
      }, true).then(value => {
        const hits: ElasticSearch.Hit<ProductSearch.Source>[] = value.data.hits.hits;
        const hit: ElasticSearch.Hit<ProductSearch.Source> = hits[0];
        this.source = hit?._source;
        this.amountOfSamples = this.quantity;
      });
    }
  }
}
